import MuiPopover from "@mui/material/Popover";
const Popover = MuiPopover;
export default Popover;
